module.exports = __webpack_public_path__ + "static/media/bg.e139aa75.jpg";